<template >
    <div>
        <v-dialog
            :value="showShareFavoritePopup"
            @input="closeDialog()" 
            class="share-favorite-dialog"
            width="320px"
        >
            <v-card>
                <v-toolbar flat>
                    <h2 class="pl-3 font-weight-regular">
                        {{ $t('share.share') }}
                    </h2>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            text
                            @click="closeDialog()"
                        >
                            <v-icon>
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <div class="d-flex share-favorite-link">
                        <div
                            id="urlToCopy"
                            class="pa-2 text-truncate"
                        >
                            {{ widgetLink }}
                        </div>

                        <v-btn
                            id="gtm-plotsidebar-cta-copy-plot"
                            text
                            class="text-none copy-cta font-weight-bold"
                            @click="copyLink()"
                        >
                            {{ $t('share.copyLink') }}
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    export default{
    
        name: 'ShareFavoriteDialog',
        props:[
            'data',
            'showShareFavoritePopup'
        ],
        computed:{
            ...mapGetters([
                'isAlternativeMode'
            ]),
            plotId() {
                return this.$props.data ? this.$props.data.plotId || (this.$props.data.type === 'plot' ? this.$route.query.id : null) : null;
            },
            widgetLink() {
                if (this.plotId)
                    return origin + "/lot?id=" + this.plotId + "&key=" + this.$route.query.key + (this.isAlternativeMode ? "&alternative": "") ;
                else {
                    const idThreeD = this.$props.data.items.find(item => item.id = "3d-plan");
                    return origin + "/plan-3d?id=" + idThreeD.subid + "&key=" + this.$route.query.key + (this.isAlternativeMode ? "&alternative": "");
                }
            },
        },
        methods: {
            ...mapActions([
                'setSnackbar'
            ]),
            copyLink() {
                let range = document.createRange();
                range.selectNode(document.getElementById("urlToCopy"));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand("copy");
                window.getSelection().removeAllRanges();
                this.closeDialog();

                this.setSnackbar({
                    'message': this.$t('share.copy'),
                    'orientation': 'top'
                });
            },
            closeDialog(){
                this.$emit('close');
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/plot/components/ShareFavoriteDialog.vue